import React, { Component } from 'react';

import UfoAnimation from '../UfoAnimation';
import * as Css from './styles';

class SayHi extends Component {
  state = {
    value: '',
  };

  handleChange = e => {
    this.setState({
      value: e.target.value,
    });
  };

  render() {
    const { value } = this.state;
    return (
      <>
        <UfoAnimation />

        <Css.Wrap>
          <Css.Form>
            <Css.FormTitle>Say hi to me</Css.FormTitle>
            <Css.InputBox>
              <Css.Input onChange={this.handleChange} value={value} />
            </Css.InputBox>
            <Css.Button
              href="mailto:richvoronov@gmail.com"
              disabled={!value.length}
            >
              {value.length ? 'Click me' : 'Write something'}
            </Css.Button>
          </Css.Form>
          <Css.LinkItem to={'/'}>
            <span>{'<'}</span> Back
          </Css.LinkItem>
        </Css.Wrap>
      </>
    );
  }
}

export default SayHi;
